import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_CLASSROOMOWNED,
  GET_CLASSROOMSOWNED,
  GET_AVAILABLE_CLASSROOMSOWNED,
  ADD_CLASSROOMOWNED,
  UPDATE_CLASSROOMOWNED,
  DELETE_CLASSROOMOWNED
} from '@/queries/modules/class-room/classRoomOwned';

export async function getClassRoomsOwned(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMSOWNED,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRoomsOwned', data.getClassRoomsOwned);
      context.commit('setSuccess', null);
      return data.getClassRoomsOwned
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAvailableClassRoomsOwned(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_AVAILABLE_CLASSROOMSOWNED,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRoomOwned', data.getAvailableClassRoomsOwned);
      context.commit('setSuccess', null);
      return data.getAvailableClassRoomsOwned
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassRoomOwned(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMOWNED,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setClassRoomOwned', data.getClassRoomOwned);
      context.commit('setSuccess', null);
      return data.getClassRoomOwned
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addClassRoomOwned(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSROOMOWNED,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const classRoomsOwned = [...context.state.classRoomsOwned];
      classRoomsOwned.push(data.addClassRoomOwned);
      context.commit('setClassRoomsOwned', classRoomsOwned);
      context.commit('setSuccess', newItemSuccess(data.addClassRoomOwned.nameLocal));

      return data.addClassRoomOwned
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateClassRoomOwned(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSROOMOWNED,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.classRoomsOwned.findIndex(item => item.id === data.updateClassRoomOwned.id);
      const classRoomsOwned = [
        ...context.state.classRoomsOwned.slice(0, index),
        data.updateClassRoomOwned,
        ...context.state.classRoomsOwned.slice(index + 1)
      ];
      context.commit('setClassRoomsOwned', classRoomsOwned);
      context.commit('setSuccess', updateItemSuccess(data.updateClassRoomOwned.nameLocal));

      return data.updateClassRoomOwned
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteClassRoomOwned(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSROOMOWNED,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.classRoomsOwned.findIndex(item => item.id === data.deleteClassRoomOwned.id);
      const classRoomsOwned = [
        ...context.state.classRoomsOwned.slice(0, index),
        ...context.state.classRoomsOwned.slice(index + 1)
      ];
      context.commit('setClassRoomsOwned', classRoomsOwned);
      context.commit('setSuccess', deleteItemSuccess(data.deleteClassRoomOwned.nameLocal));

      return data.deleteClassRoomOwned
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

